export default '/src/assets/webgl/caris/audios/global_outro.mp3'